import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { Guid } from 'guid-typescript';
import {
  GroupedLevelBenefit,
  LevelBenefit,
  LevelModel,
} from 'src/app/models/supplier-score.model';
import { SupplierService } from 'src/app/services/supplier.services';
import { ToastService } from 'src/app/services/toast.service';
import { MatFormField } from '@angular/material/input';
import { MatSelect, MatOption } from '@angular/material/select';
import { FormsModule } from '@angular/forms';


@Component({
    selector: 'app-level-benefits-modal',
    templateUrl: './level-benefits-modal.component.html',
    styleUrls: ['./level-benefits-modal.component.scss'],
    imports: [MatFormField, MatSelect, FormsModule, MatOption]
})
export class LevelBenefitsModalComponent {
  toastr = inject(ToastService);
  supplierSvc = inject(SupplierService);

  @Output() closeModal = new EventEmitter<void>();
  @Input() selectedBenefit?: GroupedLevelBenefit;
  @Input() levels?: LevelModel[];
  @Output() reloadPage = new EventEmitter<void>();
  benefit!: LevelBenefit;

  level: string = '';
  additionals: number | null = null;
  description: string = '';
  isActive: boolean = true;

  ngOnInit() {
    if (this.selectedBenefit) {
      this.level = this.selectedBenefit.levelId;
      this.additionals = this.selectedBenefit.benefitAdditional;
      this.description = this.selectedBenefit.benefitDescription;
    }
  }

  /**
   * The level select is locked only for an existing benefit. A new one used to lock it as soon as a level was picked
   * ([disabled]="level != ''"), so a wrong pick could not be changed.
   */
  isLevelLocked(): boolean {
    return !!this.selectedBenefit;
  }

  modalTitle() {
    return this.selectedBenefit
      ? 'Editar beneficio'
      : 'Añadir beneficio a nivel';
  }

  onSubmit() {
    if (!this.selectedBenefit) {
      if (this.validateForm()) {
        this.supplierSvc.postBenefit(this.benefit).subscribe({
          next: (result) => {
            this.toastr.success(
              'Beneficio',
              'Beneficio añadido correctamente.'
            );
            this.clearForm();
          },
          error: (err) => {
            this.toastr.error(
              'Error',
              'No se pudo registrar el beneficio' + err.error.error
            );
          },
        });
      }
    } else if (this.validateForm()) {
      this.supplierSvc.patchBenefit(this.benefit).subscribe({
        next: (result) => {
          this.toastr.success(
            'Beneficio editado',
            'El beneficio se ha editado correctamente.'
          );
          this.clearForm();
        },
        error: (err) => {
          this.toastr.error('Error', 'No se pudo editar el nivel.' + err.error);
        },
      });
    }
  }

  clearForm() {
    this.level = '';
    this.additionals = null;
    this.description = '';
    this.cancelClick();
  }

  validateForm() {
    if (this.level != '' && this.description != '') {
      this.benefit = {
        id: this.selectedBenefit?.benefitId
          ? Guid.parse(this.selectedBenefit.benefitId)
          : undefined,
        additional: this.additionals ? this.additionals : 0,
        levelId: this.level,
        description: this.description,
      };
      return true;
    } else {
      this.toastr.error(
        'Error',
        'No se pudo registrar el beneficio. Revise los campos obligatorios.'
      );
      return false;
    }
  }

  cancelClick() {
    this.closeModal.emit();
    this.reloadPage.emit();
  }

  validateTwoDecimals(event: any) {
    let input = event.target.value;
    input = input.replace(',', '.');
    let pattern = /^\d{0,3}(\.\d{0,2})?$/;

    if (!pattern.test(input)) {
      if (input === ',') {
        return;
      }
      event.target.value = input.slice(0, -1);
    } else {
      let parts = input.split(',');
      if (parts.length > 1) {
        parts[1] = parts[1].slice(0, 2);
        event.target.value = parts.join(',');
      }
    }
  }

  validateOnlyNumbers(event: KeyboardEvent) {
    let key = event.key;
    let inputElement = event.target as HTMLInputElement;

    if (
      ['e', 'E', '.', '-', '+'].includes(key) ||
      key === 'ArrowUp' ||
      key === 'ArrowDown' ||
      (key === ',' && inputElement.value.includes(',')) ||
      (key === ',' && inputElement.selectionStart === 0)
    ) {
      event.preventDefault();
    }

    if (this.additionals) {
      if (this.additionals < 0) {
        this.additionals = 0;
      }
      if (this.additionals > 100) {
        this.additionals = 100;
      }
    }
  }
}
